<template>
    <ul>
      <li v-for="(item, index) in forcasts" :key="index">
        {{ calculateTemp(item.json_object.main.temp) }}<sup>&deg;</sup>{{ tempType }}
        <i><img :src="populateWeatherIcon(item.json_object.weather)"></i>
        <small>{{ convertToBrowserTimeZone(item.timestamp) }}</small>
      </li>
    </ul>
</template>

<script>
import moment from 'moment'

export default {
  name: 'home-forecast',
  props: [
    'forcasts',
    'tempType'
  ],
  computed: {

  },
  methods: {
    calculateTemp (temp) {
      if (this.tempType === 'F') {
        return this.conversionCToF(temp)
      } else {
        return Math.round(temp)
      }
    },
    conversionCToF (temp) {
      return Math.round((temp * 1.8) + 32)
    },
    populateWeatherIcon (weather) {
      return '/static/img/weather/' + weather[0].icon + '.svg'
    },
    convertToBrowserTimeZone (date) {
      let utcDate = moment.utc(date).toDate()
      return moment(utcDate).local().format('ddd LT')
    }
  }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/HomeForecast.vue